/*
* @Author: gujianghua
* @Date:   2020-05-08 17:41:58
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-07-01 16:42:37
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	// 获取列表
	getDataList(params) {
	    return service({
			url: '/cloud/uac/doctorManager/doctorInfoList',
			method: 'get',
			params: params
		})
	},
	// 导出
	export(data) {
		let url = v2 + '/cloud/uac/fans/downloadExcel?' +
		  searchParamsFormatter(data)
		window.location.href = url
	},
	// 粉丝列表
	fanslist(data) {
		return service({
			url: '/cloud/uac/fans/findByFansLog',
			method: 'get',
			params: data
		})
	},
	// 专题列表
	subjectlist(data) {
		return service({
			url: '/cloud/course/v1/admin/features/admin/findUserId',
			method: 'get',
			params: data
		})
	},
	// 出版物列表
	publishlist(data) {
		return service({
			url: '/cloud/course/v1/admin/publication/admin/findByUser',
			method: 'get',
			params: data
		})
	},
	// 分享获取
	getShare(path) {
		return service({
			url: '/cloud/uac/tShare/get/' + path,
			method: 'get'
		})
	},
	// 设置分享
	saveShare(data) {
		return service({
			url: '/cloud/uac/tShare/save',
			method: 'post',
			data: data
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/dochome.js